import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {IonicModule} from '@ionic/angular';
import {TranslateModule} from '@ngx-translate/core';

import {LeadaButtonComponent} from './leada-button/leada-button.component';
import {RatingComponent} from './rating/rating.component';

import { AccordionComponent } from './accordion/accordion.component';
import {LikertQuestionComponent} from './likert-question/likert-question.component';
import {QuestionComponent} from './question/question.component';
import { ResultBarComponent } from './result-bar/result-bar.component';
import {ScaleQuestionComponent} from './scale-question/scale-question.component';
import {TextQuestionComponent} from './text-question/text-question.component';
import {YesNoQuestionComponent} from './yes-no-question/yes-no-question.component';
import {McQuestionComponent} from './mc-question/mc-question.component';
import {DownloadCertQuestionComponent} from './download-cert-question/download-cert-question.component';
import { WeekdaysPanel } from './weekdays-panel/weekdays-panel.component';
import { CollapsibleComponent } from './collapsible/collapsible.component';
import { FlipCardComponent } from './flipcard/flipcard.component';
import { InstructionComponent } from './instruction/instruction.component';
import { ArcDiagramComponent } from './arc-diagram/arc-diagram.component';
import { ContentDiagramComponent } from './content-diagram/content-diagram.component';
import { RichTextComponent } from './rich-text/rich-text.component';
import { BarDiagram } from './bar-diagram/bar-diagram';
import { MarkQueryComponent } from './mark-query/mark-query.component';

@NgModule({
    declarations: [
        LeadaButtonComponent,
        RatingComponent,
        QuestionComponent,
        ScaleQuestionComponent,
        LikertQuestionComponent,
        YesNoQuestionComponent,
        McQuestionComponent,
        DownloadCertQuestionComponent,
        TextQuestionComponent,
        AccordionComponent,
        ResultBarComponent,
        WeekdaysPanel,
        CollapsibleComponent,
        FlipCardComponent,
        InstructionComponent,
        ArcDiagramComponent,
        ContentDiagramComponent,
        RichTextComponent,
        BarDiagram,
        MarkQueryComponent,
    ],
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        TranslateModule,
    ],
    exports: [
        LeadaButtonComponent,
        RatingComponent,
        QuestionComponent,
        ScaleQuestionComponent,
        LikertQuestionComponent,
        YesNoQuestionComponent,
        McQuestionComponent,
        DownloadCertQuestionComponent,
        TextQuestionComponent,
        AccordionComponent,
        WeekdaysPanel,
        ResultBarComponent,
        CollapsibleComponent,
        FlipCardComponent,
        InstructionComponent,
        ArcDiagramComponent,
        ContentDiagramComponent,
        RichTextComponent,
        BarDiagram,
        MarkQueryComponent,
    ],
})
export class LeadaComponentsModule {}
